<div class="advanced-filters">
  <div style="display: flex">
    <button
      [disabled]="disable"
      [matMenuTriggerFor]="menu"
      #matTrigger="matMenuTrigger"
      class="advanced-filters__toggle"
      [ngClass]="selectedActiveFilters?.length > 0 ? 'change-color' : ''">
      <span class="advanced-filters__toggle-icon">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.98 1C15.99 1.01 16 1.03 16 1.06V1.72C16 1.75 15.99 1.77 15.98 1.78L10.46 8.57C10.17 8.94 10 9.41 10 9.89V14.68C10 14.72 9.98 14.74 9.97 14.74L7.02 16C7.02 16 7 15.99 7 15.94V9.89C7 9.41 6.83 8.94 6.53 8.57L1.02 1.78C1.01 1.77 1 1.75 1 1.72V1.06C1 1.02 1.01 1 1.01 1H15.98ZM16 0H1C0.45 0 0 0.47 0 1.06V1.72C0 1.97 0.09 2.22 0.24 2.41L5.76 9.2C5.91 9.39 6 9.63 6 9.89V15.95C6 16.55 6.47 17 7 17C7.12 17 7.25 16.98 7.37 16.92L10.36 15.66C10.75 15.5 11 15.11 11 14.68V9.89C11 9.64 11.09 9.39 11.24 9.2L16.76 2.41C16.91 2.22 17 1.97 17 1.72V1.06C17 0.47 16.55 0 16 0Z"
            fill="#22214C" />
        </svg>
      </span>
      <span
        class="advanced-filters__toggle-text"
        #AdvancedButton
        [matTooltipDisabled]="!disable"
        [matTooltip]="'Filters are not available with \n Group by'"
        matTooltipClass="pdq-mat-tooltip">
        Filters
        {{ selectedActiveFilters?.length > 0 ? '/ ' + selectedActiveFilters?.length : '' }}
      </span>
    </button>

    <div class="advanced-filters__chip-group">
      @for (selectedFilter of selectedActiveFilters; track selectedFilter) {
        <pdq-chip
          class="advanced-filters__chip"
          [variant]="'primary'"
          [label]="selectedFilter.name"
          (onChange)="closeAdvancedFilter(selectedFilter)">
        </pdq-chip>
      }
    </div>
  </div>
  <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook -->
  <mat-menu #menu="matMenu" class="advanced-filters__panel" xPosition="before">
    <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem">
      <div class="advanced-filters__title">Filters</div>
      @if (selectedActiveFilters?.length > 0) {
        <span class="advanced-filters__clearAll">
          <a (click)="clearThisFilter($event)">Deselect all</a>
        </span>
      }
    </div>

    <div class="advanced-filters__list">
      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook -->
      <mat-button-toggle-group
        [(ngModel)]="selectedActiveFilters"
        (change)="onChangeFilter($event)"
        [multiple]="true"
        (click)="$event.stopPropagation()"
        class="advanced-filters__group">
        @for (advancedFilter of pinnedArray; track advancedFilter) {
          <mat-button-toggle class="advanced-filters__group-button" [value]="advancedFilter">
            <span class="advanced-filters__group-button-name">
              {{ advancedFilter.name }}
              @if (advancedFilter.resultCount) {
                <span>({{ advancedFilter.resultCount }})</span>
              }
            </span>
            <pdq-icon
              icon="delete"
              (click)="
                onOpenDeleteAdvancedFilterDialog($event, advancedFilter.id, advancedFilter.name, advancedFilter)
              ">
            </pdq-icon>
            <pdq-icon icon="edit-1" class="edit" (click)="onOpenAddAdvancedFilterDialog($event, advancedFilter)">
            </pdq-icon>
            <pdq-icon
              icon="pin"
              size="large"
              (click)="onUnPinnedRow($event, advancedFilter); $event.stopPropagation()"></pdq-icon>
          </mat-button-toggle>
        }
        @if (pinnedArray?.length > 0) {
          <div style="border-bottom: 1px solid #d8d8e1; margin: 5px 0 10px 0; width: 100%"></div>
        }
        @for (advancedFilter of regularAdvancedFilterArray; track advancedFilter) {
          <mat-button-toggle class="advanced-filters__group-button" [value]="advancedFilter">
            <span class="advanced-filters__group-button-name">
              {{ advancedFilter.name }}
              @if (advancedFilter.resultCount) {
                <span>({{ advancedFilter.resultCount }})</span>
              }
            </span>
            <pdq-icon
              icon="delete"
              (click)="
                onOpenDeleteAdvancedFilterDialog($event, advancedFilter.id, advancedFilter.name, advancedFilter)
              ">
            </pdq-icon>
            <pdq-icon icon="edit-1" class="edit" (click)="onOpenAddAdvancedFilterDialog($event, advancedFilter)">
            </pdq-icon>
            <pdq-icon
              icon="pin"
              class="un-pin"
              size="large"
              (click)="onPinnedRow($event, advancedFilter); $event.stopPropagation()"></pdq-icon>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <div class="advanced-filters__actions">
      <button class="advanced-filters__actions__add-button" (click)="onAddFilterManageSide()">
        <span class="advanced-filters__actions__add-button-icon">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.5 8H9V5.5C9 5.22 8.78 5 8.5 5C8.22 5 8 5.22 8 5.5V8H5.5C5.22 8 5 8.22 5 8.5C5 8.78 5.22 9 5.5 9H8V11.5C8 11.78 8.22 12 8.5 12C8.78 12 9 11.78 9 11.5V9H11.5C11.78 9 12 8.78 12 8.5C12 8.22 11.78 8 11.5 8Z"
              fill="white" />
            <path
              d="M8.5 0C3.81 0 0 3.81 0 8.5C0 13.19 3.81 17 8.5 17C13.19 17 17 13.19 17 8.5C17 3.81 13.19 0 8.5 0ZM8.5 16C4.36 16 1 12.64 1 8.5C1 4.36 4.36 1 8.5 1C12.64 1 16 4.36 16 8.5C16 12.64 12.64 16 8.5 16Z"
              fill="white" />
          </svg>
        </span>
        <span class="advanced-filters__actions__add-button-text">Add filter</span>
      </button>
      <div>
        <pdq-button (onClick)="openManageSidePanel()"> Manage filters </pdq-button>
      </div>
    </div>
  </mat-menu>
</div>

<mat-drawer #drawer mode="over" position="end" [ngStyle]="{ top: positionTop + 'px' }" style="position: fixed">
  <div class="manage-side-bar" [ngStyle]="{ height: sideBarHeight }">
    <app-advanced-filters-manage-side
      [localStoragePinnedArrayKey]="localStoragePinnedArrayKey"
      [localStoragePriorityUnPinnedArrayKey]="localStoragePriorityUnPinnedArrayKey"
      [drawer]="drawer"
      [pinnedArray]="pinnedArray"
      [regularAdvancedFilterArray]="regularAdvancedFilterArray"
      [selectedActiveFilters]="selectedActiveFilters"
      [advancedFilters]="advancedFilters"
      (onClearAllSelected)="onClearAll($event)"
      (onSelectedFilters)="onSelectedFilters($event)"
      (onAdvancedFiltersArrayUpdate)="onAdvancedFiltersArrayAction($event)"
      (onPinnedArrayUpdate)="onPinnedArrayAction($event)"
      (saveDetect)="onSaveDetect($event)">
    </app-advanced-filters-manage-side>
  </div>
</mat-drawer>
